import React from "react";
import styles from "./About.module.scss";
import AboutBanner from "../../../../images/about.png";
import Button from "components/UI/Button/Button";
import { RiArrowRightLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.about}>
      <img src={AboutBanner} alt="about-banner" />
      <div className={styles.aboutContent}>
        <h2 className={styles.title}>About Us</h2>
        <p>
          Qreativs is a dynamic platform where creativity meets opportunity. We
          bring together passionate creative professionals and businesses to
          share ideas, collaborate and build impactful projects.
        </p>
        <p>Empowering creatives. Connecting ideas. Driving innovation.</p>
        <p>
          Whether you are an artist, designer, writer, or innovator, Qreativs is
          your space to express, connect, and grow. Share your thoughts,
          showcase your ideas, and apply for projects that excite you. At the
          same time, businesses can post real-world projects and discover the
          perfect creative minds to bring their vision to life.
        </p>
        {/* <Button
          className={styles.learnMoreBtn}
          variant="filled"
          onClick={() => {
            // navigate("/signin");
          }}
        >
          Learn more
          <RiArrowRightLine />
        </Button> */}
      </div>
    </section>
  );
};

export default About;
